import dayjs, { Dayjs } from "dayjs";

export function getDecimalYears(dayjsDate: Dayjs): number {
  const years = dayjsDate.year();
  const dayOfYear = dayjsDate.dayOfYear();
  return years + dayOfYear / 365;
}

export function getToday() {
  return dayjs();
}
